import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=6dececb8&scoped=true&"
import script from "./BaseInfo.vue?vue&type=script&lang=js&"
export * from "./BaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=6dececb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dececb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dececb8')) {
      api.createRecord('6dececb8', component.options)
    } else {
      api.reload('6dececb8', component.options)
    }
    module.hot.accept("./BaseInfo.vue?vue&type=template&id=6dececb8&scoped=true&", function () {
      api.rerender('6dececb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/view-report/components/BaseInfo.vue"
export default component.exports